import React from 'react'
import styles from './PillSwitcher.module.css'

const PillSwitcher = ({ activeView, onViewChange }) => {
    return (
        <div className={styles.pillContainer}>
            <button
                className={`${styles.pill} ${activeView === 'shortlist' ? styles.active : ''}`}
                onClick={() => onViewChange('shortlist')}
            >
                Weekly Shortlist
            </button>
            <button
                className={`${styles.pill} ${activeView === 'feed' ? styles.active : ''}`}
                onClick={() => onViewChange('feed')}
            >
                Feed
            </button>
            <button
                className={`${styles.pill} ${activeView === 'graph' ? styles.active : ''}`}
                onClick={() => onViewChange('graph')}
            >
                🔮 Graph View
            </button>
        </div>
    )
}

export default PillSwitcher
